// extracted by mini-css-extract-plugin
export var container = "_10f-0";